document.addEventListener("DOMContentLoaded", function () {
  // Funzione per ottenere la lingua della pagina
  function getPageLanguage() {
    return document.documentElement.lang || document.body.lang || 'it';
  }

  // Traduzioni
  const translations = {
    it: {
      subscribe: 'ISCRIVITI',
      allConsentsRequired: 'Tutti i consensi sono obbligatori.',
      emailRequired: 'L\'indirizzo email è obbligatorio.',
      emailInvalid: 'Inserisci un indirizzo email valido.',
      iubendaNotFound: 'Script Iubenda (_iub) non trovato. Impossibile registrare il consenso.',
      formInvalid: 'Il form non è valido:',
      consentSuccess: '✅ Consenso Iubenda registrato con successo:',
      consentError: '❌ Errore nella registrazione del consenso Iubenda:',
      consentErrorMessage: 'Si è verificato un errore durante la registrazione del consenso. Riprova.'
    },
    en: {
      subscribe: 'SUBSCRIBE',
      allConsentsRequired: 'All consents are required.',
      emailRequired: 'Email address is required.',
      emailInvalid: 'Please enter a valid email address.',
      iubendaNotFound: 'Iubenda script (_iub) not found. Cannot register consent.',
      formInvalid: 'The form is not valid:',
      consentSuccess: '✅ Iubenda consent registered successfully:',
      consentError: '❌ Error in registering Iubenda consent:',
      consentErrorMessage: 'An error occurred while registering consent. Please try again.'
    }
  };

  // Funzione per ottenere la traduzione
  function t(key) {
    const lang = getPageLanguage().substring(0, 2);
    return translations[lang] ? translations[lang][key] : translations['it'][key];
  }

  // Funzione per controllare lo stato delle checkbox e gestire il fake button
  function checkCheckboxState(form) {
    const checkboxes = form.querySelectorAll('input[type="checkbox"]');
    const fakeButton = form.querySelector('.fake-button');
    const submitButton = form.querySelector('button[type="button"]:not(.fake-button)');
    
    if (checkboxes.length > 0 && fakeButton) {
      let allChecked = true;
      checkboxes.forEach(checkbox => {
        if (!checkbox.checked) {
          allChecked = false;
        }
      });
      
      if (allChecked) {
        // Nascondi il fake button e mostra quello originale
        fakeButton.style.display = 'none';
        if (submitButton) submitButton.style.display = '';
      } else {
        // Mostra il fake button e nascondi quello originale
        fakeButton.style.display = '';
        if (submitButton) submitButton.style.display = 'none';
      }
    }
  }

  // Event delegation per le checkbox dei form Klaviyo
  document.addEventListener('change', function(event) {
    if (event.target.type === 'checkbox') {
      const klaviyoForm = event.target.closest('.klaviyo-form');
      if (klaviyoForm) {
        checkCheckboxState(klaviyoForm);
      }
    }
  });

  // Funzione per aggiungere attributi ai form Klaviyo
  function addAttributesToKlaviyoForm(form) {
    const emailInput = form.querySelector('input[type="email"]');
    if (emailInput && !emailInput.hasAttribute("data-cons-subject")) {
      emailInput.setAttribute("data-cons-subject", "email");
      console.log("Aggiunto data-cons-subject='email' al form Klaviyo:", form);
    }

    // Crea e inserisce un fake button allo stesso livello del submit button
    const submitButton = form.querySelector('button[type="button"]');
    if (submitButton && !form.querySelector('.fake-button')) {
      const fakeButton = document.createElement('button');
      fakeButton.type = 'button';
      fakeButton.className = 'fake-button account__form-submit';
      fakeButton.textContent = t('subscribe');
      
      // Inserisce il fake button allo stesso livello del submit button
      submitButton.parentNode.insertBefore(fakeButton, submitButton.nextSibling);
      
      // Nascondi il submit button originale inizialmente
      submitButton.style.display = 'none';
      
      console.log("Aggiunto fake button al form Klaviyo:", form);
    }
    
    // Controlla lo stato iniziale
    checkCheckboxState(form);
  }

  // Funzione per gestire i form Klaviyo trovati
  function processKlaviyoForms() {
    const iubendaForms = document.querySelectorAll(".klaviyo-form");
    iubendaForms.forEach((form) => {
      // Aggiungi attributi se non già processato
      if (form) {
        addAttributesToKlaviyoForm(form);
      }
    });
  }

  // Funzione per gestire il click sui button dei form Klaviyo
  function handleKlaviyoSubmit(event) {
    event.preventDefault();

    // Trova il form parent
    
    const currentForm = event.target.closest('.klaviyo-form');
    if (!currentForm) return;

    const emailInput = currentForm.querySelector('input[type="email"]');

    // Controlla che lo script di Iubenda sia presente sulla pagina
    if (
      typeof _iub === "undefined" ||
      typeof _iub.cons_instructions === "undefined"
    ) {
      console.error(t('iubendaNotFound'));
      return;
    }

    // Validazione personalizzata per form novalidate
    let isValid = true;
    let errorMessage = "";

    // Controlla se l'email è compilata e valida
    if (!emailInput || !emailInput.value.trim()) {
      isValid = false;
      errorMessage = t('emailRequired');
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value.trim())) {
      isValid = false;
      errorMessage = t('emailInvalid');
    }

    // Controlla se tutte le checkbox sono selezionate
    const checkboxes = currentForm.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      if (!checkbox.checked) {
        isValid = false;
        if (!errorMessage)
          errorMessage = t('allConsentsRequired');
      }
    });

    if (!isValid) {
      console.warn(t('formInvalid'), errorMessage);
      alert(errorMessage);
      return;
    } else {
      console.log(
        "Invio consenso a Iubenda per il form:",
        currentForm.id || "Nessun ID"
      );

      _iub.cons_instructions.push([
        "submit",
        {
          form: {
            selector: currentForm,
          },
          consent: {
            legal_notices: [
              { identifier: "privacy_policy" },
              { identifier: "cookie_policy" },
              { identifier: "term" },
            ],
          },
        },
        {
          success: function (response) {
            console.log(t('consentSuccess'), response);
            currentForm.reset();
          },
          error: function (response) {
            console.error(t('consentError'), response);
            alert(t('consentErrorMessage'));
          },
        },
      ]);
    }
  }

  // Listener per gli eventi Klaviyo
  window.addEventListener("klaviyoForms", function(e) {
    console.log('Evento Klaviyo ricevuto:', e.detail.formId);
    if (e.detail.type == 'submit') {
      // Trova il form corrispondente
      const klaviyoForm = document.querySelector(`[data-form-id="${e.detail.formId}"]`) || 
                         document.querySelector('.klaviyo-form');
      
      if (klaviyoForm) {
        console.log('Form trovato per Klaviyo event, eseguendo validazione Iubenda');
        
        // Crea un evento fittizio per riutilizzare la logica esistente
        const fakeEvent = {
          preventDefault: () => {},
          stopImmediatePropagation: () => {},
          target: klaviyoForm.querySelector('button[type="button"]') || klaviyoForm
        };
        
        // Esegui la validazione e invio a Iubenda
        handleKlaviyoSubmit(fakeEvent);
      }
    }
  });

  // Processa i form già presenti
  processKlaviyoForms();

  // Event delegation per i button dei form Klaviyo
  document.addEventListener('click', function(event) {
    // Trova il form Klaviyo associato al bottone cliccato
    const form = event.target.closest('.klaviyo-form');
    if (!form) return;

    // Controlla lo stato delle checkbox
    const checkboxes = form.querySelectorAll('input[type="checkbox"]');
    let allChecked = true;
    
    if (checkboxes.length > 0) {
      checkboxes.forEach(checkbox => {
        if (!checkbox.checked) {
          allChecked = false;
        }
      });
    }

    // Se tutte le checkbox sono selezionate, gestisce il bottone reale
    // Se non tutte sono selezionate, gestisce solo il fake button
    if (!allChecked) {
      if (event.target.matches('.klaviyo-form .fake-button')) {
      // Non fare nulla o mostra un messaggio che tutti i consensi sono richiesti
      alert(t('allConsentsRequired'));
      }
    }
  });

  // Observer per i form caricati dinamicamente
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            // Element node
            // Controlla se il nodo aggiunto è un form Klaviyo o ne contiene uno
            if (node.classList && node.classList.contains("klaviyo-form")) {
              addAttributesToKlaviyoForm(node);
            } else {
              // Cerca form Klaviyo nei nodi figli
              const klaviyoForms = node.querySelectorAll(".klaviyo-form");
              klaviyoForms.forEach(addAttributesToKlaviyoForm);
            }
          }
        });
      }
    });
  });

  // Avvia l'observer
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
